import { useMemo } from 'react';
import { Entity } from '@backstage/catalog-model';
import { useApi } from '@backstage/core-plugin-api';
import {
  catalogApiRef,
  useStarredEntities,
} from '@backstage/plugin-catalog-react';
import { useAsync } from 'react-use';
import { TECHDOCS_REF_ANNOTATION } from './constants';

/** Queries the catalog directly so the starred docs are unaffected by the sidebar filters. */
export const useStarredTechDocs = (): Entity[] => {
  const catalogApi = useApi(catalogApiRef);
  const { starredEntities } = useStarredEntities();

  const entityRefs = useMemo(
    () => Array.from(starredEntities),
    [starredEntities],
  );

  const { value } = useAsync(async () => {
    if (entityRefs.length === 0) {
      return [];
    }

    const { items } = await catalogApi.getEntitiesByRefs({ entityRefs });

    return items.filter(
      (item): item is Entity =>
        !!item?.metadata.annotations?.[TECHDOCS_REF_ANNOTATION],
    );
  }, [catalogApi, entityRefs]);

  return value ?? [];
};
